import { render, staticRenderFns } from "./LayoutSettingsLoader.vue?vue&type=template&id=7ea3a556&"
import script from "./LayoutSettingsLoader.vue?vue&type=script&lang=js&"
export * from "./LayoutSettingsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports